const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 });
const dateFmt = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('en-IN', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

/** Money is stored in paise; 50100 → ₹501. */
export function formatPaise(paise: number): string {
  return inr.format(paise / 100).replace(/\.00$/, '');
}

export function formatDate(iso: string | undefined): string {
  return iso ? dateFmt.format(new Date(iso)) : '—';
}

export function formatDateTime(iso: string | undefined): string {
  return iso ? dateTimeFmt.format(new Date(iso)) : '—';
}

export function formatNumber(n: number): string {
  return n.toLocaleString('en-IN');
}

export function titleCase(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Monthly salary range in paise → "₹18,000 – ₹25,000 /month". */
export function formatSalaryRange(min?: number, max?: number, hidden?: boolean): string {
  if (hidden) return 'Salary not disclosed';
  if (min === undefined && max === undefined) return 'Salary not specified';
  if (min !== undefined && max !== undefined && min !== max) return `${formatPaise(min)} – ${formatPaise(max)} /month`;
  return `${formatPaise((max ?? min)!)} /month`;
}

export function formatExperience(min: number, max: number): string {
  if (min === 0 && max === 0) return 'Freshers';
  if (min === 0) return `0–${max} yrs`;
  if (max <= min) return `${min}+ yrs`;
  return `${min}–${max} yrs`;
}

export function formatMonths(months: number): string {
  if (!months) return 'Fresher';
  const y = Math.floor(months / 12);
  const m = months % 12;
  return [y ? `${y} yr${y > 1 ? 's' : ''}` : '', m ? `${m} mo` : ''].filter(Boolean).join(' ');
}

const rtf = new Intl.RelativeTimeFormat('en-IN', { numeric: 'auto' });
export function formatRelative(iso: string | undefined): string {
  if (!iso) return '';
  const diffSec = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diffSec);
  if (abs < 60) return 'just now';
  if (abs < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
  if (abs < 86_400) return rtf.format(Math.round(diffSec / 3600), 'hour');
  if (abs < 30 * 86_400) return rtf.format(Math.round(diffSec / 86_400), 'day');
  return formatDate(iso);
}

export const rupeesToPaise = (rupees: number | undefined) =>
  rupees === undefined || Number.isNaN(rupees) ? undefined : Math.round(rupees * 100);
export const paiseToRupees = (paise: number | undefined) => (paise === undefined ? undefined : paise / 100);
